<template>
  <div>
    <modal
      v-for="item in items"
      :key="item.index"
      v-bind="item"
      :on-after-close="onModalClose"
    />
  </div>
</template>

<script>
import Vue   from 'vue';
import Modal from "./Modal";

export default {
  name:       "ModalContainer",
  components: { Modal },
  data() {
    return {
      nextIndex: 1,
      items:     [],
    };
  },
  methods: {
    open( props, options = {} ) {
      document.body.classList.add('modal-active');

      let resolve;
      let reject;
      let rejectPredicate = null;
      const result = new Promise(( res, rej ) => {
        resolve = res;
        reject = rej;
      });
      const item = {
        // type,
        index:         this.nextIndex++,
        active:        true,
        resolve:       ( data ) => resolve(data),
        reject:        ( data ) => {
          if (typeof rejectPredicate !== "function") return reject(data);
          try {
            const result = rejectPredicate();
            if (result && result.then) {
              return result.then(( data ) => {
                data ? resolve(data) : reject(data);
              });
            } else {
              result ? resolve(result) : reject(result);
            }
          } catch (e) {
            console.log(e);
          }
        },
        onBeforeClose: ( fn ) => rejectPredicate = fn,
        result,
        props,
        options,
      };

      const close = () => item.active = false;
      result.then(close, close);

      this.items.push(item);
      return item;
    },

    onKeyDown( e ) {
      const { items } = this;
      if (!items.length) return;

      if (e.keyCode === 27) { // ESC
        e.preventDefault();
        e.stopPropagation();
        const topItem = items[items.length - 1];
        if (topItem.options.closeOnEsc === false) return;
        topItem.reject();
      }
    },

    onModalClose( index ) {
      this.items = this.items.filter(item => item.index !== index);
      if (!this.items.length) document.body.classList.remove('modal-active');
    },
  },
  mounted() {
    Vue.prototype.$modal = {
      open:        this.open,
      openConfirm: ( { message, buttonText, buttonColor, size, closeOnEsc, onAccept } ) => this.open({
        size:           size || 'xs',
        component:      () => import('./ModalConfirm'),
        componentProps: { message, buttonText, buttonColor, onAccept },
      }, { closeOnEsc }),
    };
    window.addEventListener('keydown', this.onKeyDown);
  },
  destroyed() {
    window.removeEventListener('keydown', this.onKeyDown);
  },
  watch: {
    $route() {
      const { items } = this;
      items.forEach(item => {
        if (item.active) item.reject();
      });
    },
  },
};
</script>

<style module>
:global(.modal-active) {
  overflow: hidden;
}
</style>
